<template>
    <div class="recorder">
        <a v-if="!result" href="#" class="option" @click.prevent="toggle">
            <img src="/images/record-small.svg" alt="">
            <div class="label">{{ started ? window.t('general_stop') : window.t('general_record') }}</div>
        </a>
        <br>
        <a v-if="result" class="label after-record" href="#" @click.prevent="result.play()">play</a>
        <a v-if="result" class="label after-record" href="#" @click.prevent="reset()">delete</a>
    </div>
</template>
<script>
    export default {
        props: {
            value: null,
        },
        data() {
            return {
                window,
                audioChunks: [],
                recorder: null,
                result: null,
                started: false,
                recorderType: null,
            };
        },
        mounted() {
            if (this.value) {
                const audioBlob = this.value;
                const audioUrl = URL.createObjectURL(this.value);
                const audio = new Audio(audioUrl);
                const play = () => audio.play();

                this.result = { audioBlob, audioUrl, play };
            }
        },
        methods: {
            async createRecorder() {
                return new Promise(async resolve => {
                        const stream = await window.navigator.mediaDevices.getUserMedia({ audio: true });
                        const mediaRecorder = new MediaRecorder(stream);

                        this.recorderType = null;

                        mediaRecorder.addEventListener("dataavailable", event => {
                            this.recorderType = event.data.type;
                            this.audioChunks.push(event.data);
                        });

                        const start = () => mediaRecorder.start();

                        const stop = () => new Promise(resolve => {
                            mediaRecorder.addEventListener("stop", (e) => {
                                const audioBlob = new Blob(this.audioChunks, {
                                    'type': this.recorderType
                                });
                                this.$emit('update:value',audioBlob);
                                const audioUrl = URL.createObjectURL(audioBlob);
                                const audio = new Audio(audioUrl);
                                const play = () => audio.play();

                                resolve({ audioBlob, audioUrl, play });
                            });

                            mediaRecorder.stop();
                        });

                        resolve({ start, stop });
                    });
            },
            async init() {
                if(!this.recorder) {
                    this.recorder = await this.createRecorder();
                }
            },
            async start() {
                this.reset();
                await this.init();
                this.recorder.start();
            },
            async stop() {
                await this.init();
                this.result = await this.recorder.stop();
            },
            reset() {
                this.result = null;
                this.audioChunks = [];
                this.$emit('update:value',null);
            },
            async toggle() {
                if (this.started) {
                    await this.stop();
                    this.started = false;
                } else {
                    await this.start();
                    this.started = true;
                }
            },
            sleep(time) {
                return new Promise(resolve => setTimeout(resolve, time));
            }
        }
    }
</script>
